import React, { useState } from "react";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faShare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { UserCog2Icon } from "lucide-react";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import UserPermission from "../../UserPermission/UserPermission";

const UserActionButton = ({
  id,
  setEdit,
  setUserId,
  toggleShowAddEditUser,
  toggleShowDelete,
  userData,
  fetchUser,
  deletedUser,
  toggleShowResend,
  activeUser,
  admin,
}) => {
  const [showPermission, setShowPermission] = useState();

  const toggleShowPermission = () => {
    setShowPermission(!showPermission);
  };

  const handleSucess = () => {
    toggleShowPermission();
    fetchUser();
  };

  return !admin ? (
    <>
      <span className="flex items-center gap-2 justify-center">
        {!activeUser && (
          <>
            <CustomTooltip message={"Resend Invitation"}>
              <span>
                <FontAwesomeIcon
                  icon={faShare}
                  size="1x"
                  onClick={() => {
                    setUserId(id);
                    toggleShowResend();
                  }}
                />
              </span>
            </CustomTooltip>
            <span>/</span>
          </>
        )}
        {!deletedUser && (
          <>
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    setEdit(true);
                    toggleShowAddEditUser();
                    setUserId(id);
                  }}
                />
              </span>
            </CustomTooltip>
            <span>/</span>
            <CustomTooltip message={"Delete"}>
              <span>
                <FontAwesomeIcon
                  icon={faTrash}
                  size="1x"
                  onClick={() => {
                    setUserId(id);
                    toggleShowDelete();
                  }}
                />
              </span>
            </CustomTooltip>
            <span>/</span>
            <CustomTooltip message={"User Permission"}>
              <span>
                <UserCog2Icon
                  size={16}
                  onClick={() => {
                    setUserId(id);
                    toggleShowPermission();
                  }}
                />
              </span>
            </CustomTooltip>
          </>
        )}
      </span>

      <ResponsiveDrawerForm
        description={""}
        title={"User Permission"}
        handleOpen={() => {}}
        handleClose={() => {}}
        buttonText={""}
        className={"sm:max-w-[90vw] overflow-hidden"}
        setOpen={setShowPermission}
        open={showPermission}
        write={true}
      >
        <UserPermission
          expandList={true}
          userId={id}
          userData={userData}
          handleSucess={() => {
            handleSucess();
          }}
        />
      </ResponsiveDrawerForm>
    </>
  ) : (
    <></>
  );
};

export default UserActionButton;
